import React from "react";
import ListView from "../Common/Views/ListView";

const CustomersList = ({
    filters = {},
    addButton = true,
    onSelect = null, // a function to override the table row click action (default is to navigate to details page)

    columns = null, // array if specific columns from the columnsConfig to show in the list view. If null, all columns will be shown.
}) => {

    // Columns configuration for rendering items list
    const columnsConfig = {
        name: {
            key: 'name',
            label: 'Name',
            render: row => row.name
        },
        type: {
            key: 'phoneNumber',
            label: 'Phone number',
            render: row => row.phoneNumber
        },
        email: {
            key: 'email',
            label: 'Email address',
            render: row => row.email
        },
        address: {
            key: 'address',
            label: 'Address',
            render: row => row.address
        },
        isActive: {
            key: 'isActive',
            label: 'Active',
            render: row => row.isActive ? 'Yes' : 'No'
        },
    };


    return <ListView
        title="Customers"
        apiPath="/tenants/customers"
        filters={filters}
        addButton={addButton}
        addButtonLabel="Add new customer"
        addPath="/customers/add"
        rowClickPath={(customer) => `/customers/${customer.id}`}
        onSelect={onSelect}
        columnsConfig={columnsConfig}
        columns={columns}
        searchBox={true}
        searchAttributes={[
            { name: 'name', label: 'Name', type: 'text' },
            { name: 'phoneNumber', label: 'Phone number', type: 'text' },
            { name: 'email', label: 'Email address', type: 'text' },
        ]}
        noResultsMessage="No customers found"
    />
};

export default CustomersList;
